/**
 * Created by ALEC on ???
 */



import React from "react";
import { FormattedMessage } from 'react-intl';
import CDNImage from '../media/image.js';
import CDNAudio from '../../classes/audio.js';
import { Table } from 'react-bootstrap';

export default class TranslationTable extends React.Component {

    constructor(props) {
        super();
        this.state = {
            vocab: props.vocab || [],
            edit: props.edit || function () { },
            sortByWord: props.sortByWord || function () { },
            isPlain: props.isPlain || false,
            setLive: props.setLive || function () { }
        }

    }

    setData(data) {
        this.setState({ vocab: data })
    }

    setIsPlain(isPlain) {
        this.setState({ isPlain: isPlain })
    }

    componentWillReceiveProps(props) {
        this.setState({ vocab: props.vocab })
    }

    handleAudioClick(src) {
        (new CDNAudio(src)).play();
    }

    componentWillReceiveProps(props) {
        this.setState({ vocab: props.vocabs || [], edit: props.edit || function () { }, sortByWord: props.sortByWord })
    }

    createButton(idx) {
        return <button onClick={function () {
            var vocab = this.state.vocab[idx];
            this.state.edit(vocab);
        }.bind(this)
        } type="button" className="btn btn-icon command-delete waves-effect waves-circle" data-row-id="10253"><span className="zmdi zmdi-edit"></span></button>
    }


    sortByImage() {

    }

    sortByUid() {

    }

    sortByAudio() {

    }


    renderRow() {
        var items = [];
        if (this.state.vocab == undefined) return <div></div>

        items.push(<tr className={"animate-color p-0"}>
            <td>
                {"Image"}
            </td>
            <td>
                {"Uid"}
            </td>
            <td>
                {"Word"}
            </td>
            <td>
                {"English"}
            </td>

            <td>
                {"Last Updated"}
            </td>
            <td>
                {"Image Filename"}
            </td>
            <td>
                {"Audio  Filename"}
            </td>
            <td>
                {"Language"}
            </td>
            <td>
                {"Is Live"}
            </td>

            <td className="p-0" width={90}>
                <button onClick={function () {  }.bind(this)}
                    type="button" >Audio</button>

            </td>
            <td>
                {""}
            </td>
            <td>
                {""}
            </td>
            <td>
                {""}
            </td>

            <td width="50" className="text-right">

                {"Edit"}

            </td>


        </tr>)



        for (var idx = 0; idx < this.state.vocab.length; idx++) {


            if (this.state.vocab[idx].picture == undefined) {
                var imageCol = "";
            } else {
                var imageCol = <td width={110}><CDNImage size={90} isVocab src={this.state.vocab[idx].picture}></CDNImage></td>;
            }

            if (this.state.vocab[idx].audio != undefined) {
                var button = <button onClick={this.handleAudioClick.bind(this, this.state.vocab[idx].audio)} type="button" className="palette-White-Disabled bg m-r-30 small btn btn-icon command-edit waves-effect waves-circle" data-row-id="10248">
                    <CDNImage className="m-b-5" size={15} src="img/audioWordPod.png" />
                </button>
            } else {
                var button = "";
            }

            items.push(<tr className={"animate-color p-0"}>
                {imageCol}
                <td>
                    {this.state.vocab[idx].uid}
                </td>
                <td>
                    {this.state.vocab[idx].text}
                </td>
                <td>
                    {this.state.vocab[idx].text2}
                </td>
                <td>
                    {this.state.vocab[idx].last_updated}
                </td>
                <td>
                    {this.state.vocab[idx].picture}
                </td>
                <td>
                    {this.state.vocab[idx].audio}
                </td>
                <td>
                    {this.state.vocab[idx].language_uid}
                </td>
                <td>
                    {this.getIsLiveEditFunction(idx)}
                </td>
                <td className="p-0" width={90}>
                    <center className="p-5">
                        {button}
                    </center>
                </td>
                <td className="p-0" width={40}>

                    <center></center>
                </td>
                <td></td>

                <td width="50" className="text-right">

                    {this.createButton(idx)}

                </td>


            </tr>)

        }

        return items;
    }

    renderPlainRow() {
        var items = [];
        if (this.state.vocab == undefined) return <div></div>

        items.push(<tr className={"animate-color p-0"}>

            <td>
                {"Uid"}
            </td>

            <td>
                {"Translation"}
            </td>

            <td>
                {"English"}
            </td>

            <td>
                {"Last Updated"}
            </td>
            <td></td>
            <td></td>
            <td>
                {"Audio"}
            </td>
            <td>
                {"Language"}
            </td>
            <td>
                {"Is Live"}
            </td>
            <td></td>
            <td></td>
            <td width="50" className="text-right">
                {"Edit"}
            </td>



        </tr>)



        for (var idx = 0; idx < this.state.vocab.length; idx++) {

            if (!(this.state.vocab[idx].uid == 2163 || this.state.vocab[idx].uid == 2164)) {

                if (this.state.vocab[idx].picture == undefined) {
                    var imageCol = "";
                } else {
                    var imageCol = <td width={110}><CDNImage size={90} isVocab src={this.state.vocab[idx].picture}></CDNImage></td>;
                }

                if (this.state.vocab[idx].audio != undefined) {
                    var button = <button onClick={this.handleAudioClick.bind(this, this.state.vocab[idx].audio)} type="button" className="palette-White-Disabled bg m-r-30 small btn btn-icon command-edit waves-effect waves-circle" data-row-id="10248">
                        <CDNImage className="m-b-5" size={15} src="img/audioWordPod.png" />
                    </button>
                } else {
                    var button = "";
                }

                items.push(<tr className={"animate-color p-0"}>
                    {imageCol}
                    <td>
                        {this.state.vocab[idx].uid}
                    </td>
                    <td>
                        {this.state.vocab[idx].text}
                    </td>
                    <td>
                        {this.state.vocab[idx].text2}
                    </td>
                    <td>
                        {this.state.vocab[idx].last_updated}
                    </td>
                    <td>
                        {this.state.vocab[idx].picture}
                    </td>
                    <td>
                        {this.state.vocab[idx].audio}
                    </td>
                    <td>
                        {this.state.vocab[idx].language_uid}
                    </td>
                    <td>
                        {this.getIsLiveEditFunction(idx)}
                    </td>
                    <td className="p-0" width={90}>
                        <center className="p-5">
                            {button}
                        </center>
                    </td>
                    <td className="p-0" width={40}>

                        <center></center>
                    </td>

                    <td width="50" className="text-right">

                        {this.createButton(idx)}

                    </td>


                </tr>)
            }
        }

        return items;
    }

    getIsLiveEditFunction(idx) {
        return (<div><input type="checkbox"
            type='checkbox'
            name={'checkbox'}
            id={'checkbox'}
            checked={this.state.vocab[idx].is_live == "1"}
            onChange={function () { this.swapEdit(idx) }.bind(this)} /> <i className="input-helper"></i></div>);
    }

    swapEdit(idx) {
        if (this.state.vocab[idx].is_live == "1") {
            this.state.vocab[idx].is_live = "0";
            this.state.setLive(this.state.vocab[idx], false);
        } else {
            this.state.vocab[idx].is_live = "1";
            this.state.setLive(this.state.vocab[idx], true);
        };
        this.setState({});
    }

    render() {
        if (this.state.isPlain) {
            return (
                <Table condensed striped responsive bordered>
                    <tbody>
                        {this.renderPlainRow()}
                    </tbody>
                </Table>
            );
        } else {


            return (
                <Table condensed striped responsive bordered>
                    <tbody>
                        {this.renderRow()}
                    </tbody>
                </Table>
            );
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/tables/translation-table.js